export default "__VITE_ASSET__Dq8$P4dE__"